import { useContext } from "react"
import { AppContext } from "../../components"

export const useStepUpToken = () => {
  const { stepUpToken } = useContext(AppContext)
  return stepUpToken
}
